<script lang="ts">
  import { app } from './lib/state.svelte';
  import Home from './routes/Home.svelte';
  import Session from './routes/Session.svelte';
  import Finish from './routes/Finish.svelte';
  import History from './routes/History.svelte';
  import Pair from './routes/Pair.svelte';

  void app.init();
</script>

<!-- Status strip. Offline is a normal state here, not an error, so it says so
     quietly and never blocks anything. -->
{#if !app.online || app.pending > 0 || app.saveError || app.updateReady || app.rejected > 0}
  <div class="strip" class:bad={!!app.saveError || app.rejected > 0}>
    {#if app.saveError}
      {app.saveError}
    {:else if app.rejected > 0}
      {app.rejected} write{app.rejected === 1 ? " was" : "s were"} refused by the server
    {:else if app.updateReady}
      <button onclick={() => app.applyUpdate()}>New version ready - tap to update</button>
    {:else if !app.online}
      Offline{app.pending > 0 ? ` · ${app.pending} saved here` : ''}
    {:else}
      {app.pending} syncing
    {/if}
  </div>
{/if}

{#if app.screen === 'loading'}
  <p class="loading">…</p>
{:else if app.screen === 'pair'}
  <Pair />
{:else if app.screen === 'session'}
  <Session />
{:else if app.screen === 'finish'}
  <Finish />
{:else if app.screen === 'history'}
  <History />
{:else}
  <Home />
{/if}

<style>
  .strip {
    position: sticky;
    top: 0;
    z-index: 10;
    background: var(--panel);
    border-bottom: 1px solid var(--line);
    color: var(--dim);
    font-size: 0.78rem;
    letter-spacing: 0.03em;
    padding: 6px 12px;
    text-align: center;
  }

  .strip.bad {
    background: var(--bad-bg);
    color: var(--bad-text);
  }

  .strip button {
    background: none;
    border: 0;
    color: var(--accent);
    font: inherit;
    text-decoration: underline;
  }

  .loading {
    color: var(--line);
    text-align: center;
    padding: 40vh 0;
  }
</style>
